export * from "ce/pages/UserAuth/SignUp";
import * as CE_SignUp from "ce/pages/UserAuth/SignUp";
export default CE_SignUp.default;
